const EXPERIENCES_URI = '/experiences';
const EDUCATIONS_URI = '/educations';

const BOTH_SIDE_CERTS = ['driver_license', 'passport'];

const EXPERIENCE = 'experience';
const EDUCATION = 'education';
const HOBBIES = 'hobbies';
const INTERESTS = 'interests';
const WORDS = 'words';
const CHARACTERISTICS = 'characteristics';
const SKILLS = 'skills';
const QUALIFICATIONS = 'qualifications';
const CERTIFICATE = 'certificate';
const NAME = 'name';
const DOB = 'dob';
const SEX = 'sex';
const HOMETOWN = 'hometown';
const RESIDENCE = 'residence';
const ALLERGY = 'allergy';

(function () {
  var addCloseBtnEvent,
    addDefaultFormXhrEvent,
    addInfoLinkEvent,
    addMultiValueFormXhrEvent,
    addNameFormXhrEvent,
    addPlaceFormXhrEvent,
    addPresentCheckEvent,
    addResumeFormXhrEvent,
    allergyCheckTrueEvent,
    buildAllergyForm,
    buildCertificateForm,
    buildDefaultForm,
    buildDobForm,
    buildForm,
    buildMultiValueForm,
    buildNameForm,
    buildPlaceForm,
    buildSexForm,
    changeFormElementId,
    controlCertSubmitByUploadedStatus,
    getInfoGroup,
    isOverseasCheckEvent,
    loadResumeForm,
    refreshValidation,
    registerFormError,
    removeRequiredMark,
    toggleRequiredMark;

  changeFormElementId = function (dom, suffix) {
    if (!suffix) {
      suffix = 'ot';
    }
    dom.find('label').attr('for', function (e) {
      return $(this).attr('for') + '_' + suffix;
    });
    return dom.find('input, textarea, select').attr('id', function (e) {
      var elem_id;
      elem_id = $(this).attr('id');
      if (elem_id) {
        return elem_id + '_' + suffix;
      }
    });
  };

  buildDefaultForm = function (body) {
    var field, form, id, label, lebel, name, placeholder, type, url, val;
    type = body.attr('data-type');
    lebel = body.attr('data-label');
    url = body.attr('data-url');
    id = body.attr('data-id');
    name = body.attr('data-name');
    val = body.attr('data-value') || '';
    placeholder = body.attr('data-placeholder') || '';
    form = $('#info-form-container').find('form.default-form').clone(true);
    form.attr('action', url);
    label = $('<label for="' + id + '" class="sr-only">' + lebel + '</label>');
    if (type === 'textarea') {
      field = $('<textarea></textarea>')
        .attr({
          id: id,
          name: name,
          rows: 8,
        })
        .addClass('form-control')
        .text(val);
    } else if (type === 'tel') {
      field = $('<input />')
        .attr({
          id: id,
          name: name,
          type: 'tel',
          pattern: '^[0-9+-]*$',
          placeholder: '012-3456-7890',
        })
        .addClass('form-control')
        .val(val);
    } else if (type === 'email') {
      field = $('<input />')
        .attr({
          id: id,
          name: name,
          type: 'email',
          placeholder: 'info@otetsutabi.com',
          required: true,
        })
        .addClass('form-control')
        .val(val);
      form.submit(function (e) {
        return confirm(
          body.attr('data-confirmation') +
            '\n' +
            form.find('input[type="email"]').val(),
        );
      });
    } else {
      field = $('<input />')
        .attr({
          id: id,
          name: name,
          type: 'text',
        })
        .addClass('form-control')
        .val(val);
    }
    form.find('div.form-group').append($('<div />').append(label, field));
    changeFormElementId(form);
    addDefaultFormXhrEvent(form);
    return form;
  };

  buildDobForm = function (body) {
    var day, form, month, val, year, _ref;
    val = body.attr('data-value') || '';
    form = $('#info-form-container').find('form.dob-form').clone(true);
    if (val) {
      (_ref = val.split('-')),
        (year = _ref[0]),
        (month = _ref[1]),
        (day = _ref[2]);
      form
        .find('select.form-control')
        .prepend('<optgroup disabled></optgroup>');
      form
        .find('select.dob-year option[value=' + year + ']')
        .attr('selected', true);
      form
        .find('select.dob-month option[value=' + parseInt(month) + ']')
        .attr('selected', true);
      form
        .find('select.dob-day option[value=' + parseInt(day) + ']')
        .attr('selected', true);
    }
    changeFormElementId(form);
    addDefaultFormXhrEvent(form);
    return form;
  };

  buildSexForm = function (body) {
    var form, val;
    val = body.attr('data-value') || '';
    form = $('#info-form-container').find('form.sex-form').clone(true);
    if (val) {
      form
        .find('select#user_sex option[value=' + val + ']')
        .attr('selected', true);
      form
        .find('select.form-control')
        .prepend('<optgroup disabled></optgroup>');
    }
    changeFormElementId(form);
    addDefaultFormXhrEvent(form);
    return form;
  };

  buildAllergyForm = function (body) {
    var form, val;
    val = body.attr('data-value') || '';
    form = $('#info-form-container').find('form.allergy-form').clone(true);
    if (val) {
      form.find('.allergy-check-true').attr('checked', true);
      form.find('textarea#user_profile_allergy').val(val);
    } else {
      form.find('.allergy-check-false').attr('checked', true);
    }
    allergyCheckTrueEvent(form.find('.allergy-check-true'));
    changeFormElementId(form);
    addDefaultFormXhrEvent(form);
    return form;
  };

  addDefaultFormXhrEvent = function (form) {
    return $(form).on('ajax:success', function (e) {
      var body,
        columnGroup,
        content,
        data,
        display_key,
        editionLink,
        infoForm,
        key,
        registration,
        status,
        title,
        type,
        xhr,
        _ref,
        _ref1;
      (_ref = e.detail), (data = _ref[0]), (status = _ref[1]), (xhr = _ref[2]);
      (_ref1 = getInfoGroup(e.target)),
        (columnGroup = _ref1[0]),
        (title = _ref1[1]),
        (body = _ref1[2]),
        (infoForm = _ref1[3]);
      columnGroup.removeClass('border-0');
      body.removeClass('d-none');
      type = body.attr('data-type');
      key = body.attr('data-key');
      registration = body.attr('data-registration');
      body.attr('data-value', data[key]);
      content = body.find('.user-info-content').off();
      editionLink = body.find('.user-info-edition-link');
      if (type === ALLERGY) {
        key = 'allergy_text';
      }
      if (data[key] !== null && data[key] !== '') {
        content.removeClass('user-info-registration');
        editionLink.removeClass('d-none');
        display_key =
          type === DOB ? 'dob_text' : type === SEX ? 'sex_text' : key;
        content.find('span:not(.material-icons)').text(data[display_key]);
        removeRequiredMark(key);
      } else {
        content.addClass('user-info-registration');
        editionLink.addClass('d-none');
        content.find('span:not(.material-icons)').text(registration);
        addInfoLinkEvent(content);
      }
      return infoForm.addClass('d-none').find('form').remove();
    });
  };

  buildMultiValueForm = function (body) {
    var form,
      i,
      id_prefix,
      prefix,
      type,
      v,
      val,
      _i,
      _j,
      _len,
      _len1,
      _ref,
      _ref1;
    type = body.attr('data-type');
    val = body.attr('data-value') || '';
    prefix = body.attr('data-prefix');
    form = $('#info-form-container')
      .find('form.' + type + '-form')
      .clone(true);
    id_prefix = prefix + type + '_';
    if (
      type === HOBBIES ||
      type === INTERESTS ||
      type === SKILLS ||
      type === CHARACTERISTICS
    ) {
      _ref = val.split(',');
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        v = _ref[_i];
        form.find('input#' + id_prefix + v).prop('checked', true);
      }
    } else if (type === WORDS || type === QUALIFICATIONS) {
      i = 0;
      _ref1 = val.split(',');
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        v = _ref1[_j];
        form.find('input#' + id_prefix + i).val(v);
        i++;
      }
    }
    changeFormElementId(form);
    addMultiValueFormXhrEvent(form);
    return form;
  };

  addMultiValueFormXhrEvent = function (form) {
    return $(form).on('ajax:success', function (e) {
      var body,
        columnGroup,
        content,
        data,
        editionLink,
        ids,
        infoForm,
        names,
        registration,
        status,
        title,
        type,
        values,
        xhr,
        _ref,
        _ref1,
        _ref2;
      (_ref = e.detail), (data = _ref[0]), (status = _ref[1]), (xhr = _ref[2]);
      (_ref1 = getInfoGroup(e.target)),
        (columnGroup = _ref1[0]),
        (title = _ref1[1]),
        (body = _ref1[2]),
        (infoForm = _ref1[3]);
      columnGroup.removeClass('border-0');
      body.removeClass('d-none');
      type = body.attr('data-type');
      registration = body.attr('data-registration');
      values = data[type] || [];
      (_ref2 = [[], []]), (ids = _ref2[0]), (names = _ref2[1]);
      values.forEach(function (v) {
        ids.push(v.id);
        return names.push(v.name);
      });
      body.attr(
        'data-value',
        type === WORDS || type === QUALIFICATIONS
          ? names.join(',')
          : ids.join(','),
      );
      content = body.find('.user-info-content').off();
      editionLink = body.find('.user-info-edition-link');
      if (values.length > 0) {
        content.removeClass('user-info-registration');
        editionLink.removeClass('d-none');
        content.find('span:not(.material-icons)').text(names.join('、'));
        removeRequiredMark(type);
      } else {
        content.addClass('user-info-registration');
        editionLink.addClass('d-none');
        content.find('span:not(.material-icons)').text(registration);
        addInfoLinkEvent(content);
      }
      return infoForm.addClass('d-none').find('form').remove();
    });
  };

  loadResumeForm = function (dom) {
    var attr,
      attrs,
      body,
      columnGroup,
      deleteBtn,
      description,
      end_date,
      form,
      id,
      industry,
      isNew,
      modal,
      modalTitle,
      preSetDate,
      start_date,
      title,
      type,
      url,
      _i,
      _len,
      _ref;
    (_ref = getInfoGroup(dom)),
      (columnGroup = _ref[0]),
      (title = _ref[1]),
      (body = _ref[2]);
    type = body.attr('data-type');
    url = body.attr('data-url');
    id = body.attr('data-id') || null;
    description = body.attr('data-description');
    start_date = body.attr('data-start-date');
    end_date = body.attr('data-end-date') || null;
    modal = $($(dom).attr('data-target'));
    form = modal.find('form');
    form.attr({
      action: url,
      'data-id': id,
    });
    isNew = $(dom).attr('data-new') === 'true';
    form.find('input[name="_method"]').prop('disabled', isNew);
    deleteBtn = form.find('.delete-btn').attr('href', url);
    modalTitle = modal.find('.modal-title');
    if (isNew) {
      deleteBtn.addClass('d-none');
      modalTitle.text(modalTitle.attr('data-registration'));
    } else {
      deleteBtn.removeClass('d-none');
      modalTitle.text(modalTitle.attr('data-change'));
    }
    attrs =
      type === EXPERIENCE ? ['organization', 'role'] : ['school', 'faculty'];
    for (_i = 0, _len = attrs.length; _i < _len; _i++) {
      attr = attrs[_i];
      form
        .find('input[name="' + type + '[' + attr + ']"]')
        .val(title.find('span[data-attr="' + attr + '"]').text() || '');
    }
    form.find('textarea[name="' + type + '[description]"]').val(description);
    if (type === EXPERIENCE) {
      industry = body.attr('data-industry-id') || '';
      form
        .find('select[name="experience[industry_id]"]')
        .children('option[value="' + industry + '"]')
        .prop('selected', true);
    }
    preSetDate = function (date, wrapperClassName) {
      var month, wrapper, year, _ref1;
      (_ref1 = date ? date.split('-') : ['', '']),
        (year = _ref1[0]),
        (month = _ref1[1]);
      wrapper = form.find('.' + wrapperClassName);
      wrapper
        .find('select.year-select')
        .children('option[value="' + year + '"]')
        .prop('selected', true);
      return wrapper
        .find('select.month-select')
        .children('option[value="' + (month ? parseInt(month) : month) + '"]')
        .prop('selected', true);
    };
    preSetDate(start_date, 'start-date-wrapper');
    preSetDate(end_date, 'end-date-wrapper');
    addPresentCheckEvent(
      form
        .find('.present-check')
        .prop('checked', start_date && end_date === null),
    );
    return form;
  };

  addResumeFormXhrEvent = function (form) {
    return $(form).on('ajax:success', function (e) {
      var attr,
        body,
        body_attrs,
        columnGroup,
        data,
        modal,
        registrationColumnGroup,
        registrationLink,
        status,
        title,
        title_attrs,
        type,
        xhr,
        _i,
        _j,
        _len,
        _len1,
        _ref,
        _ref1,
        _ref2;
      (_ref = e.detail), (data = _ref[0]), (status = _ref[1]), (xhr = _ref[2]);
      type = $(this).attr('data-type');
      body = $(
        '*[data-type="' +
          type +
          '"][data-id="' +
          $(this).attr('data-id') +
          '"]',
      );
      (_ref1 = getInfoGroup(body)),
        (columnGroup = _ref1[0]),
        (title = _ref1[1]);
      modal = $(this).closest('.modal');
      if (body.length === 0) {
        registrationLink = $(
          '.user-resume-registration[data-target="#' + modal.attr('id') + '"]',
        );
        registrationColumnGroup = getInfoGroup(registrationLink)[0];
        (_ref2 = getInfoGroup(registrationColumnGroup.clone(true))),
          (columnGroup = _ref2[0]),
          (title = _ref2[1]),
          (body = _ref2[2]);
        registrationColumnGroup.before(columnGroup);
        columnGroup.removeClass('border-bottom-0');
        title.removeClass('d-none');
        body.removeClass('d-none');
        columnGroup.find('.user-info-resume-body').remove();
      }
      if (xhr.status === 204) {
        columnGroup.remove();
      } else {
        title_attrs =
          type === EXPERIENCE
            ? ['organization', 'role']
            : ['school', 'faculty'];
        title_attrs.push('term');
        for (_i = 0, _len = title_attrs.length; _i < _len; _i++) {
          attr = title_attrs[_i];
          title.find('span[data-attr="' + attr + '"]').text(data[attr] || '');
        }
        body.find('.user-info-content').text(data['term']);
        body_attrs = ['id', 'description', 'start_date', 'end_date'];
        if (type === EXPERIENCE) {
          body_attrs.push('industry_id');
        } else {
          ['faculty', 'department'];
        }
        for (_j = 0, _len1 = body_attrs.length; _j < _len1; _j++) {
          attr = body_attrs[_j];
          body.attr('data-' + attr.replace('_', '-'), data[attr]);
        }
        body.attr(
          'data-url',
          (type === EXPERIENCE ? EXPERIENCES_URI : EDUCATIONS_URI) +
            '/' +
            data['id'],
        );
        removeRequiredMark(type);
      }
      return modal.modal('hide');
    });
  };

  buildCertificateForm = function (body) {
    var form;
    form = $('#info-form-container').find('form.certificate-form').clone(true);
    changeFormElementId(form);
    return form;
  };

  buildNameForm = function (body) {
    var form, name, _i, _len, _ref;
    form = $('#info-form-container').find('form.name-form').clone(true);
    _ref = ['first_name', 'last_name', 'first_name_kana', 'last_name_kana'];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      name = _ref[_i];
      form
        .find('input#user_' + name)
        .val(body.attr('data-' + name.replace(/_/g, '-')) || '');
    }
    changeFormElementId(form);
    addNameFormXhrEvent(form);
    return form;
  };

  addNameFormXhrEvent = function (form) {
    return $(form).on('ajax:success', function (e) {
      var body,
        columnGroup,
        content,
        data,
        editionLink,
        fullName,
        greeting,
        infoForm,
        name,
        registration,
        status,
        title,
        xhr,
        _i,
        _len,
        _ref,
        _ref1,
        _ref2;
      (_ref = e.detail), (data = _ref[0]), (status = _ref[1]), (xhr = _ref[2]);
      (_ref1 = getInfoGroup(e.target)),
        (columnGroup = _ref1[0]),
        (title = _ref1[1]),
        (body = _ref1[2]),
        (infoForm = _ref1[3]);
      columnGroup.removeClass('border-0');
      body.removeClass('d-none');
      registration = body.attr('data-registration');
      _ref2 = ['first_name', 'last_name', 'first_name_kana', 'last_name_kana'];
      for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
        name = _ref2[_i];
        body.attr('data-' + name.replace(/_/g, '-'), data[name] || '');
      }
      content = body.find('.user-info-content').off();
      editionLink = body.find('.user-info-edition-link');
      fullName = data['full_name'];
      if (fullName) {
        content.removeClass('user-info-registration');
        editionLink.removeClass('d-none');
        content.find('span:not(.material-icons)').text(fullName);
        removeRequiredMark(NAME);
      } else {
        content.addClass('user-info-registration');
        editionLink.addClass('d-none');
        content.find('span:not(.material-icons)').text(registration);
        addInfoLinkEvent(content);
      }
      greeting = data['greeting'];
      if (greeting) {
        $('.greeting').text(greeting);
      }
      return infoForm.addClass('d-none').find('form').remove();
    });
  };

  buildPlaceForm = function (body) {
    var chx,
      country_id,
      data,
      dom,
      existing_val,
      form,
      place,
      tagName,
      type,
      _i,
      _len,
      _new;
    type = body.attr('data-type');
    _new = body.attr('data-new');
    country_id = body.attr('data-country-id') || '';
    form = $('#info-form-container')
      .find('form.' + type + '-form')
      .clone(true);
    if (_new === 'true') {
      form.find('input[name="_method"]').attr('disabled', true);
    }
    data = ['country_id', 'region_id', 'region_name', 'city'];
    if (type === RESIDENCE) {
      data.push('zip');
      data.push('street_address');
      data.push('building');
    }
    for (_i = 0, _len = data.length; _i < _len; _i++) {
      place = data[_i];
      dom = form.find('*[name$="[' + place + ']"]');
      existing_val = body.attr('data-' + place.replace(/_/g, '-')) || '';
      if (dom.length === 0 || existing_val === null) {
        continue;
      }
      tagName = dom[0].tagName.toLowerCase();
      if (tagName === 'input') {
        dom.val(existing_val);
      } else if (tagName === 'select') {
        dom
          .children('option[value="' + existing_val + '"]')
          .prop('selected', true);
      }
    }
    chx = form
      .find('.overseas-check')
      .attr('checked', country_id !== null && country_id !== '');
    isOverseasCheckEvent(chx);
    changeFormElementId(form);
    addPlaceFormXhrEvent(form);
    return form;
  };

  addPlaceFormXhrEvent = function (form) {
    return $(form).on('ajax:success', function (e) {
      var body,
        columnGroup,
        content,
        data,
        editionLink,
        infoForm,
        keys,
        place,
        registration,
        status,
        title,
        type,
        values,
        xhr,
        _i,
        _len,
        _ref,
        _ref1;
      (_ref = e.detail), (data = _ref[0]), (status = _ref[1]), (xhr = _ref[2]);
      (_ref1 = getInfoGroup(e.target)),
        (columnGroup = _ref1[0]),
        (title = _ref1[1]),
        (body = _ref1[2]),
        (infoForm = _ref1[3]);
      columnGroup.removeClass('border-0');
      body.removeClass('d-none');
      registration = body.attr('data-registration');
      type = body.attr('data-type');
      values = {};
      keys = ['country_id', 'region_id', 'region_name', 'city'];
      if (type === RESIDENCE) {
        keys.push('zip');
        keys.push('street_address');
        keys.push('building');
      }
      for (_i = 0, _len = keys.length; _i < _len; _i++) {
        place = keys[_i];
        body.attr('data-' + place.replace(/_/g, '-'), data[place] || '');
        if (data[place]) {
          values[place] = data[place];
        }
      }
      body.attr('data-new', false);
      content = body.find('.user-info-content').off();
      editionLink = body.find('.user-info-edition-link');
      if (Object.keys(values).length > 0) {
        content.removeClass('user-info-registration');
        editionLink.removeClass('d-none');
        content.find('span:not(.material-icons)').text(data['text']);
        removeRequiredMark(type);
      } else {
        content.addClass('user-info-registration');
        editionLink.addClass('d-none');
        content.find('span:not(.material-icons)').text(registration);
        addInfoLinkEvent(content);
      }
      return infoForm.addClass('d-none').find('form').remove();
    });
  };

  buildForm = function (body) {
    var type;
    type = body.attr('data-type');
    if (
      [
        HOBBIES,
        INTERESTS,
        WORDS,
        SKILLS,
        QUALIFICATIONS,
        CHARACTERISTICS,
      ].includes(type)
    ) {
      return buildMultiValueForm(body);
    } else if (type === CERTIFICATE) {
      return buildCertificateForm(body);
    } else if (type === NAME) {
      return buildNameForm(body);
    } else if (type === DOB) {
      return buildDobForm(body);
    } else if (type === SEX) {
      return buildSexForm(body);
    } else if (type === HOMETOWN || type === RESIDENCE) {
      return buildPlaceForm(body);
    } else if (type === ALLERGY) {
      return buildAllergyForm(body);
    } else {
      return buildDefaultForm(body);
    }
  };

  getInfoGroup = function (dom) {
    var columnGroup;
    columnGroup = $(dom).closest('.user-info-column-group');
    return [
      columnGroup,
      columnGroup.find('.user-info-title'),
      columnGroup.find('.user-info-body'),
      columnGroup.find('.user-info-form'),
    ];
  };

  addInfoLinkEvent = function (dom) {
    if (!dom) {
      dom = $('.user-info-registration, .user-info-edition-link');
    }
    return dom.click(function (e) {
      var body, columnGroup, infoForm, title, _ref;
      e.preventDefault();
      (_ref = getInfoGroup(this)),
        (columnGroup = _ref[0]),
        (title = _ref[1]),
        (body = _ref[2]),
        (infoForm = _ref[3]);
      columnGroup.addClass('border-0');
      body.addClass('d-none');
      return infoForm.removeClass('d-none').append(buildForm(body));
    });
  };

  addCloseBtnEvent = function () {
    return $('#info-form-container form')
      .find('.close-btn')
      .click(function (e) {
        var body, columnGroup, infoForm, title, _ref;
        (_ref = getInfoGroup(this)),
          (columnGroup = _ref[0]),
          (title = _ref[1]),
          (body = _ref[2]),
          (infoForm = _ref[3]);
        columnGroup.removeClass('border-0');
        title.removeClass('d-none');
        body.removeClass('d-none');
        return infoForm.addClass('d-none').find('form').remove();
      });
  };

  addPresentCheckEvent = function (chx) {
    var endDateWrapper, form, present;
    form = $(chx).closest('form');
    endDateWrapper = form.find('.end-date-wrapper');
    present = form.find('.word-present');
    if ($(chx).prop('checked')) {
      endDateWrapper.addClass('d-none');
      present.removeClass('d-none');
    } else {
      endDateWrapper.removeClass('d-none');
      present.addClass('d-none');
    }
    return endDateWrapper
      .find('select')
      .attr('required', !$(chx).prop('checked'));
  };

  isOverseasCheckEvent = function (chx) {
    var country_id, form, hideField, region_id, region_name, showField;
    form = $(chx).closest('form');
    country_id = form.find('*[name$="[country_id]"]');
    region_id = form.find('*[name$="[region_id]"]');
    region_name = form.find('*[name$="[region_name]"]');
    showField = function (field) {
      return field
        .attr({
          disabled: false,
          required: true,
        })
        .parents('.form-group')
        .removeClass('d-none');
    };
    hideField = function (field) {
      return field
        .attr({
          disabled: true,
          required: false,
        })
        .parents('.form-group')
        .addClass('d-none');
    };
    if ($(chx).prop('checked')) {
      showField(country_id);
      hideField(region_id);
      return showField(region_name);
    } else {
      hideField(country_id);
      showField(region_id);
      return hideField(region_name);
    }
  };

  allergyCheckTrueEvent = function (rbx) {
    var allergy, form;
    form = $(rbx).closest('form');
    allergy = form.find('*[name$="[allergy]"]');
    if ($(rbx).prop('checked') && $(rbx).hasClass('allergy-check-true')) {
      return allergy
        .attr({
          disabled: false,
          required: false,
        })
        .parents('.form-group')
        .removeClass('d-none');
    } else {
      return allergy
        .attr({
          disabled: true,
          required: false,
        })
        .parents('.form-group')
        .addClass('d-none');
    }
  };

  controlCertSubmitByUploadedStatus = function () {
    var cert_type, fileUploaded;
    fileUploaded = true;
    $('.cert-file').each(function () {
      var fileSize;
      fileSize = this.files.length > 0 ? this.files[0].size : 0;
      if (
        !$(this).parents('.cert-upload-box').hasClass('d-none') &&
        fileSize === 0
      ) {
        return (fileUploaded = false);
      }
    });
    cert_type = $('#user_cert_type').children('option:selected').val();
    if (!cert_type) {
      fileUploaded = false;
    }
    return $('#userCertForm')
      .find('button[type="submit"]')
      .attr('disabled', !fileUploaded);
  };

  refreshValidation = function (element) {
    $(element).find('.valid-feedback, .invalid-feedback').remove();
    return $(element).find('*').removeClass('is-invalid');
  };

  registerFormError = function () {
    return $('form').on('ajax:error', function (e) {
      var data,
        field,
        form,
        invalid,
        key,
        status,
        xhr,
        _i,
        _len,
        _ref,
        _ref1,
        _results;
      (_ref = e.detail), (data = _ref[0]), (status = _ref[1]), (xhr = _ref[2]);
      form = $(e.target);
      refreshValidation(form);
      _ref1 = Object.keys(data || {});
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        key = _ref1[_i];
        field = form.find('*[name$="[' + key + ']"]');
        invalid = $(
          '<div class="invalid-feedback white-space-pre-line text-left">' +
            data[key] +
            '</div>',
        );
        if (field.length > 0) {
          _results.push(field.addClass('is-invalid').after(invalid));
        } else {
          _results.push(
            form
              .find('*[data-invalid="' + key + '"]')
              .append(invalid.addClass('d-block')),
          );
        }
      }
      return _results;
    });
  };

  $(document).ready(function () {
    addInfoLinkEvent();
    addCloseBtnEvent();
    $('.present-check').change(function (e) {
      return addPresentCheckEvent(this);
    });
    $('.overseas-check').change(function (e) {
      return isOverseasCheckEvent(this);
    });
    $('.allergy-check-true, .allergy-check-false').change(function (e) {
      return allergyCheckTrueEvent(this);
    });
    $('.user-resume-registration, .user-resume-edition-link').click(function (
      e,
    ) {
      return loadResumeForm(this);
    });
    addResumeFormXhrEvent($('.user-resume-form'));
    registerFormError();
    $('.modal').on('show.bs.modal', function (e) {
      return refreshValidation(e.target);
    });
    $('#user_cert_type').change(function (e) {
      var certBackImage, selected;
      selected = $(this).children('option:selected').val();
      certBackImage = $('#user_certificate_back_blob');
      if (selected === '' || BOTH_SIDE_CERTS.includes(selected)) {
        certBackImage
          .attr('disabled', false)
          .parents('.cert-upload-box')
          .removeClass('d-none');
      } else {
        certBackImage
          .attr('disabled', true)
          .parents('.cert-upload-box')
          .addClass('d-none');
      }
      $('#certHelpBlock')
        .find('span:not(.material-icons)')
        .each(function (e) {
          if ($(this).attr('data-cert') === selected) {
            return $(this).removeClass('d-none');
          } else {
            return $(this).addClass('d-none');
          }
        });
      return controlCertSubmitByUploadedStatus();
    });
    $('.cert-file').change(function (e) {
      var certBox, certClose, file, image, imageWrapper, reader, uploadWrapper;
      file = e.target.files[0];
      if (!file) {
        return;
      }
      certBox = $(this).closest('.cert-upload-box');
      uploadWrapper = certBox.find('.cert-upload-wrapper').addClass('d-none');
      certClose = certBox.find('.cert-close').removeClass('d-none');
      imageWrapper = certBox.find('.cert-image-wrapper').removeClass('d-none');
      uploadWrapper.find('input[type="file"]').attr('disabled', true);
      certBox.find('img.preview-cert').remove();
      image = $('<img>');
      imageWrapper.append(image);
      if (URL) {
        image.attr('src', URL.createObjectURL(file));
      } else {
        reader = new FileReader();
        reader.onload = function (re) {
          return image.attr('src', re.target.result);
        };
        reader.readAsDataURL(file);
      }
      return image.on('load', function () {
        var imageHeight, imageWidth;
        imageWidth = image.width();
        imageHeight = image.height();
        if (imageWidth > imageHeight) {
          image.css({
            width: '100%',
            maxHeight: '100%',
          });
        } else {
          image.css({
            height: '100%',
            maxWidth: '100%',
          });
        }
        image.addClass('preview-cert');
        certBox.addClass('preview');
        return controlCertSubmitByUploadedStatus();
      });
    });
    $('form#userCertForm')
      .on('ajax:before', function (e) {
        var certBackImage, certFrontImage, selected;
        selected = $('#user_cert_type').children('option:selected').val();
        certFrontImage = $('#user_certificate_front_blob');
        certBackImage = $('#user_certificate_back_blob');
        if (selected === '' || BOTH_SIDE_CERTS.includes(selected)) {
          certFrontImage.attr('disabled', false);
          certBackImage.attr('disabled', false);
        } else {
          certFrontImage.attr('disabled', false);
        }
        return $(this).find('input[type="submit"]').attr('disabled', true);
      })
      .on('ajax:success', function (e) {
        var certLink, data, modal, status, xhr, _ref;
        modal = $(this).closest('.modal');
        modal.on('hidden.bs.modal', function (e) {
          return $(this).remove();
        });
        modal.modal('hide');
        (_ref = e.detail),
          (data = _ref[0]),
          (status = _ref[1]),
          (xhr = _ref[2]);
        certLink = $('#certUploadLink');
        certLink.after('<span>' + data['certificate'] + '</span>');
        certLink.remove();
        return removeRequiredMark(CERTIFICATE);
      })
      .on('ajax:complete', function (e) {
        return $(this).find('input[type="submit"]').attr('disabled', false);
      });
    return $('.cert-close').click(function (e) {
      var certBox, file, uploadWrapper;
      e.preventDefault();
      certBox = $(this).closest('.cert-upload-box');
      uploadWrapper = certBox
        .find('.cert-upload-wrapper')
        .removeClass('d-none');
      $(this).addClass('d-none');
      certBox.find('.cert-image-wrapper').addClass('d-none');
      file = uploadWrapper.find('input[type="file"]').attr('disabled', false);
      if (file.length > 0) {
        file[0].value = '';
      }
      certBox.removeClass('preview');
      certBox.find('img.preview-cert').remove();
      return controlCertSubmitByUploadedStatus();
    });
  });

  toggleRequiredMark = function (key, isAdd) {
    var body, columnGroup, element, markSelector, title, _ref;
    if (isAdd == null) {
      isAdd = true;
    }
    element = null;
    if (key === 'image') {
      element = $('button[data-type="' + key + '"]');
    } else {
      body = $('.user-info-body[data-type="' + key + '"]');
      if (body.length === 0) {
        body = $('.user-info-body[data-key="' + key + '"]');
      }
      (_ref = getInfoGroup(body)), (columnGroup = _ref[0]), (title = _ref[1]);
      if ([EXPERIENCE, EDUCATION].includes(key)) {
        element = columnGroup.find('.user-info-resume-body');
      } else {
        element = title;
      }
    }
    if (!element) {
      return;
    }
    markSelector = 'required-mark';
    if (isAdd) {
      return element.addClass(markSelector);
    } else {
      return element.removeClass(markSelector);
    }
  };

  removeRequiredMark = function (key) {
    if (window.location.search.indexOf('?p=') !== -1) {
      toggleRequiredMark(key, false);
      if ($('body').find('.required-mark, .RequiredChip').length === 0) {
        return $('#applicationFixed')
          .find('input[type="submit"]')
          .attr('disabled', false);
      }
    }
  };

  this.markRequired = function (targets) {
    var key, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = targets.length; _i < _len; _i++) {
      key = targets[_i];
      _results.push(toggleRequiredMark(key));
    }
    return _results;
  };

  global.markRequired = this.markRequired;
}.call(this));
